import React, { useContext } from 'react';
import { AgendaContext } from '../../contexts/AgendaContext';
import { useBlocker } from 'react-router-dom';
// Modals
import ModalExit from '../SolicitudDeConexion/Modals/ModalExit.flujosSolicitud';

function RouterBlocker({ children, clearForm, blockCondition, currentComponent }) {

    const { useBlockerOK } = useContext(AgendaContext);

    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) => {
            if (currentComponent === 'registro') {
                return blockCondition && (currentLocation.pathname.split('/').includes('registro')) && useBlockerOK;
            }
            return blockCondition && (currentLocation.pathname !== nextLocation.pathname);
        }
    );

    return (
        <>
            {children}
            <ModalExit open={blocker.state === 'blocked'} blocker={blocker} clearFunction={clearForm} />
        </>
    );
}

export default RouterBlocker;